import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React, { lazy } from 'react';
import ReactDOM from 'react-dom';

import './services';

import { Provider } from 'react-redux';
import { ConfigProvider } from "./contexts/ConfigContext";
import ErrorBoundary from './views/maintenance/ErrorBoundary'
import './index.scss';
import 'sweetalert2/dist/sweetalert2.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import store from "./store";
import { ExportProvider } from 'contexts/ExportContext';
import { TimeFormatProvider } from "contexts/TimeFormatContext"
import { BrowserRouter } from 'react-router-dom';
import './i18n';

// ReactDOM.render(
//     <Provider store={store}>
//         <ConfigProvider>
//             <ExportProvider>
//             <App />
//             </ExportProvider>
//         </ConfigProvider>
//     </Provider>,
//   document.getElementById('root')
// );


const hash = window.location.hash;
let RootComponent;

if (hash.startsWith('#/print/report')) {
  const PrintReport = require('views/panels/hospital/ClassicReport/PrintReport').default
  RootComponent = (<ConfigProvider><TimeFormatProvider><BrowserRouter><PrintReport /></BrowserRouter></TimeFormatProvider></ConfigProvider>)
} else {
  RootComponent = (
    <Provider store={store}>
      <ErrorBoundary>
        <ConfigProvider>
          <ExportProvider >
            <App />            
          </ExportProvider>
        </ConfigProvider>
      </ErrorBoundary>
    </Provider>
  );
}

ReactDOM.render(
  RootComponent,
  document.getElementById('root')
);

reportWebVitals(console.log);
//registerServiceWorker();

// if (process.env.REACT_APP_ENABLE_SW && process.env.REACT_APP_ENABLE_SW === 'false') {
//     serviceWorkerRegistration.unregister();
// } else {
//     serviceWorkerRegistration.register();    
// }
//serviceWorkerRegistration.register();